import { render, staticRenderFns } from "./questionDetail.vue?vue&type=template&id=264d6eeb&scoped=true&"
import script from "./questionDetail.vue?vue&type=script&lang=js&"
export * from "./questionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d6eeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('264d6eeb')) {
      api.createRecord('264d6eeb', component.options)
    } else {
      api.reload('264d6eeb', component.options)
    }
    module.hot.accept("./questionDetail.vue?vue&type=template&id=264d6eeb&scoped=true&", function () {
      api.rerender('264d6eeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/answer/commonAnswer/questionDetail.vue"
export default component.exports